/* eslint-disable max-len */
import angular, { IAttributes, IDirective } from 'angular';
import { RootScope } from '../../app.config';
import { EExternalAPI } from '../../src/app/@shared-types/api';

const AccessibleAPIDirective: angular.IDirectiveFactory = (): IDirective => ({
  controller: ($rootScope: RootScope, $element: JQLite, $attrs: IAttributes): void => {
    'ngInject';

    const toggleVisibility = () => {
      if ($rootScope.globals.accessibleApis && $attrs.accessibleApi) {
        if (!($rootScope.globals.accessibleApis as EExternalAPI[]).includes($attrs.accessibleApi)) {
          $element.remove();
        }
      }
    };

    $rootScope.$on('updateAPIDirectives', () => {
      toggleVisibility();
    });

    toggleVisibility();
  },
  restrict: 'A',
});

const EnabledAPIDirective: angular.IDirectiveFactory = (): IDirective => ({
  controller: ($rootScope: RootScope, $element: JQLite, $attrs: IAttributes): void => {
    'ngInject';

    const toggleVisibility = () => {
      const apis: string[] = [];
      if ($attrs.enabledApi.includes(',')) {
        apis.push(...$attrs.enabledApi.split(','));
      } else {
        apis.push($attrs.enabledApi);
      }

      if ($rootScope.globals.enabledApis && $attrs.enabledApi) {
        const canUseAnyApi = apis.some((api) => $rootScope.globals.enabledApis.includes(api as EExternalAPI));

        if (!canUseAnyApi) $element.remove();
      }
    };

    $rootScope.$on('updateAPIDirectives', () => {
      toggleVisibility();
    });

    toggleVisibility();
  },
  restrict: 'A',
});

/**
 * This directive can toggle the visibility of elements if the user is allowed to see them or not.
 * The `hasPermission` attribute defines `frontendAction`, which is assigned to roles.
 * After all permissions are received by the server,
 * all directives are called to validate the visibility.
 */
export default angular.module('services.permissions', [])
  .directive('accessibleApi', AccessibleAPIDirective)
  .directive('enabledApi', EnabledAPIDirective)
  .name;
